import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api_call from '../../../globals/common_utilities/axios_old';
import CONSTANTURL from '../../../globals/common_utilities/constanturls';
import { API } from '../../../globals/constants';

const initialState = {
	loading: false,
	error: '',
	CreateTraining: [],
	AutoAssign: [],
	TrainingById: [],
	RescheduleTraining: [],
};

export const CreateTraining = createAsyncThunk(
	'createTraining/api',
	({ bodyParam }) => {
		return api_call(
			'post',
			`${
				CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
				API.END_POINTS.GET_TRAINING_LISTING
			}`,
			{},
			{},
			bodyParam
		);
	}
);
const CreateTrainingSlice = createSlice({
	name: 'createTraining',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(CreateTraining.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(CreateTraining.fulfilled, (state, action) => {
			state.loading = false;
			state.CreateTraining = action.payload;
			state.error = '';
		});
		builder.addCase(CreateTraining.rejected, (state, action) => {
			state.loading = false;
			state.CreateTraining = [];
			state.error = action.error.message;
		});
	},
});
export const AutoAssign = createAsyncThunk(
	'AutoAssign/api',
	({ bodyParam }) => {
		return api_call(
			'post',
			`${
				CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING_EXTEND +
				API.END_POINTS.AUTO_ASSIGN
			}`,
			{},
			{},
			bodyParam
		);
	}
);
const AutoAssignSlice = createSlice({
	name: 'AutoAssign',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(AutoAssign.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(AutoAssign.fulfilled, (state, action) => {
			state.loading = false;
			state.AutoAssign = action.payload;
			state.error = '';
		});
		builder.addCase(AutoAssign.rejected, (state, action) => {
			state.loading = false;
			state.AutoAssign = [];
			state.error = action.error.message;
		});
	},
});
export const TrainingList = createAsyncThunk(
	'trainigList/api',
	({ params }) => {
		return api_call(
			'get',
			`${
				CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
				API.END_POINTS.TRAINING_BY_ID
			}`,
			params,
			{},
			{}
		);
	}
);
const TrainingListSlice = createSlice({
	name: 'trainigList',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(TrainingList.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(TrainingList.fulfilled, (state, action) => {
			state.loading = false;
			state.TrainingById = action.payload;
			state.error = '';
		});
		builder.addCase(TrainingList.rejected, (state, action) => {
			state.loading = false;
			state.TrainingById = [];
			state.error = action.error.message;
		});
	},
});
export const RescheduleTraining = createAsyncThunk(
	'rescheduleTraining/api',
	({ params, bodyParam }) => {
		return api_call(
			'post',
			`${
				CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
				API.END_POINTS.RESCHEDULE
			}`,
			params,
			{},
			bodyParam
		);
	}
);
const RescheduleTrainingSlice = createSlice({
	name: 'rescheduleTraining',
	initialState,
	extraReducers: (builder) => {
		builder.addCase(RescheduleTraining.pending, (state) => {
			state.loading = true;
		});
		builder.addCase(RescheduleTraining.fulfilled, (state, action) => {
			state.loading = false;
			state.RescheduleTraining = action.payload;
			state.error = '';
		});
		builder.addCase(RescheduleTraining.rejected, (state, action) => {
			state.loading = false;
			state.RescheduleTraining = [];
			state.error = action.error.message;
		});
	},
});
export const CreateTrainings = {
	CreateTraining: CreateTrainingSlice.reducer,
	AutoAssign: AutoAssignSlice.reducer,
	TrainingById: TrainingListSlice.reducer,
	RescheduleTraining: RescheduleTrainingSlice.reducer,
};
